import { RouterModule, Routes, Router } from '@angular/router';
import { NgModule } from '@angular/core';
import { NewuploadComponent } from '../components/newupload/newupload.component';
import { ErrorComponent } from '../components/error/error.component';
import { TokenService } from '../service/token.service';

const routes: Routes = [
    {path:'upload',component: NewuploadComponent, canActivate:[TokenService]},
    {path:'error',component: ErrorComponent},
    { path: 'error/:id', component: ErrorComponent },
    { path: '**', redirectTo: 'error/404' },
    {path:'',redirectTo:'/',pathMatch: 'full',canActivate:[TokenService]}];
@NgModule({
    imports:[RouterModule.forRoot(routes,{useHash: true})],
    exports:[RouterModule]
})
export class RoutingModule{}